import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import SVGImage from '~/components/Image/SVGImage'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import useTestPrepProductCardStats from '~/statistics/hooks/useTestPrepProductCardStats'
import { TestPrepProductAPIStat } from '~/redux/apis/user-stats-api'

import TimeStat from '../../ProfileCards/TimeStat'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  product: TestPrepProductAPIStat
}

export default function Summary({ showContent, onClick, product }: Props): React.ReactElement {
  const { t } = useTranslation(['statistics', 'imageAlt'])

  const {
    gradeTitle,
    timeSpent: { days, hours, minutes },
    correctnessPercentage,
  } = useTestPrepProductCardStats(product)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: gradeTitle })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={gradeTitle}
        curriculumCountryCode={product.curriculumCountryCode}
        iconAltText={t('imageAlt:icons.products.testPrep')}
        iconSrcKey="icons/products/test_prep_badge.png"
        onClickTitle={onClickTitle}
        productSubtitle=""
        productTitle={t('testPrep')}
        shouldShowCurriculum={product.shouldShowCurriculum}
        showContent={showContent}
        titleClassname="text-orchid-dark"
      />
      <div className="font-medium flex justify-between">
        <div className="flex items-center">
          <SVGImage
            alt={t('statistics:alt_texts.clock')}
            className="mr-2"
            height={20}
            srcKey="scoreboard/clock.svg"
            width={20}
          />
          <TimeStat days={days} hours={hours} minutes={minutes} />
        </div>
        <p>
          {t('statistics:correct-answer')} {correctnessPercentage}%
        </p>
      </div>
    </button>
  )
}
